import { api } from '@api'
import { v4 } from 'uuid'

export const processMessageMedia = async (content: string, channelId: string) => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(content, 'text/html')

  const imgElements = Array.from(doc.querySelectorAll('img'))
  const audioElements = Array.from(doc.querySelectorAll('audio'))
  const mentions = Array.from(doc.querySelectorAll('.mention'))

  // Process Images (Base64 -> Supabase Storage)
  // TODO: add rollback for orphaned files on insert failure
  await Promise.all(
    imgElements.map(async (img) => {
      const src = img.getAttribute('src')
      if (!src || !src.startsWith('data:image')) return

      const mimeMatch = src.match(/^data:(image\/[a-zA-Z]+);base64,/)
      if (!mimeMatch) return

      const mime = mimeMatch[1]
      const fileExt = mime.split('/')[1]
      const base64Data = src.split(',')[1]

      const byteChars = atob(base64Data)
      const byteArray = new Uint8Array(Array.from(byteChars, (c) => c.charCodeAt(0)))
      const blob = new Blob([byteArray], { type: mime })

      const fileName = `${channelId}/${v4()}.${fileExt}`

      const { error } = await api().storage.from('channel-files').upload(fileName, blob, { contentType: mime })
      if (error) throw new Error(`Image upload failed: ${error.message}`)

      img.setAttribute('src', fileName)
    })
  )

  // Process Audio (Blob -> Supabase Storage)
  await Promise.all(
    audioElements.map(async (audio) => {
      const src = audio.getAttribute('src')
      if (!src || !src.startsWith('blob:')) return

      const response = await fetch(src)
      const blob = await response.blob()
      const mime = blob.type || 'audio/webm'
      const ext = mime.split('/')[1] || 'webm'
      const fileName = `${channelId}/${v4()}.${ext}`

      const { error } = await api().storage.from('channel-files').upload(fileName, blob, { contentType: mime })
      if (error) throw new Error(`Audio upload failed: ${error.message}`)

      audio.setAttribute('src', fileName)
    })
  )

  // Extract Mentions safely
  const parsedMentions = mentions.map(mention => ({
    userId: mention.getAttribute('data-id'),
    username: mention.getAttribute('data-value'), // TODO this isnt needed remove from here and schema
  })).filter(m => m.userId && m.username)

  return {
    updatedContent: doc.body.innerHTML,
    mentions: parsedMentions
  }
}
